<template>
	<div id="MainCardLayout">
        <HrrBreadcrumb PMname="岗位计划管理" CMname="岗位计划申报汇总(京外)" />
        <HrrMainCardLayout>
            <template slot="custom">
                <el-form :inline="true" :model="searchform">
                    <el-form-item label="计划：">
                        <el-select v-model="searchform.planId" placeholder="请选择">
                            <el-option v-for="item in planIdData" :key="item.planId" :label="item.planName" :value="item.planId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="SubmitForm">查询</el-button>
                    </el-form-item>
                </el-form>
              <el-tabs v-model="tab" type="card" >
                <el-tab-pane label="高校毕业生岗位" name="graduates">
                        <el-table :data="graduatesData" ref="graduatesData"
                        border
                        stripe
                        highlight-current-row
                        v-loading="gloading"
                        style="width: 100%" >
                            <el-table-column prop="instituteName" label="单位" width="180" fixed="left" >
                            </el-table-column>
                            <el-table-column prop="orgName" label="部门" width="150" fixed="left" sortable>
                            </el-table-column>
                            <el-table-column prop="postTitle" label="岗位名称" width="150" fixed="left">
                            </el-table-column>
                            <el-table-column prop="postInfo" label="岗位简介" width="180">
                            </el-table-column>
                            <el-table-column prop="needNum" label="招聘人数" width="50">
                            </el-table-column>
                            <el-table-column prop="major" label="专业" width="180">
                            </el-table-column>
                            <el-table-column prop="educationTypeName" label="学历" width="80" sortable>
                            </el-table-column>
                            <el-table-column prop="diplomaTypeName" label="学位" width="80" sortable>
                            </el-table-column>
                            <el-table-column prop="politicalType" label="政治面貌" width="110" sortable>
                            </el-table-column>
                            <el-table-column prop="gWrittenProportion" label="计划录用人数与笔试人选的确定比例" width="100">
                            </el-table-column>
                            <el-table-column prop="gInterviewProportion" label="计划录用人数与面试人选的确定比例" width="100">
                            </el-table-column>
                            <el-table-column prop="gIsProfessional" label="是否组织专业考试" width="100">
                                <template slot-scope="scope">
                                    {{scope.row.gIsProfessional==true?"是":"否"}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="gReviewType" label="考察方式" width="110" sortable>
                            </el-table-column>
                            <el-table-column prop="other" label="其他条件" width="180">
                            </el-table-column>
                            <el-table-column prop="gSourceType" label="生源要求" width="110" sortable>
                            </el-table-column>
                            <el-table-column prop="remark" label="备注" width="180">
                            </el-table-column>
                            <el-table-column label="状态" width="110" align="center" fixed="right">
                                <template slot-scope="scope">
                                    <el-tag  type="primary" disable-transitions v-if="scope.row.status==0">{{scope.row.statusName}}</el-tag>
                                    <el-tag  type="danger" disable-transitions v-if="scope.row.status==10" >{{scope.row.statusName}}</el-tag>
                                    <el-tag  type="success" disable-transitions v-if="scope.row.status==20" >{{scope.row.statusName}}</el-tag>
                                    <el-tag  type="info" disable-transitions v-if="scope.row.status==-10" >{{scope.row.statusName}}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="140" fixed="right">
                                <template slot-scope="scope">
                                    <el-button type="text"
                                    v-show="showbutn(scope.row.status)"
                                    @click.stop="changeStatus(scope.row.postId,20,'g')"
                                    size="small" class="text-success">通过</el-button>
                                    <el-button type="text"
                                    v-show="showbutn(scope.row.status)"
                                    @click.stop="changeStatus(scope.row.postId,-10,'g')"
                                    size="small" class="text-danger">不通过</el-button>
                                    <el-button type="text"
                                    v-show="showbutn(scope.row.status)"
                                    @click.stop="changeStatus(scope.row.postId,10,'g')"
                                    size="small" class="text-info">调整</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                         <br />
                        <el-pagination
                        background
                        @size-change="ghandleSizeChange"
                        @current-change="ghandleCurrentChange"
                        :current-page="gfrom.pageNum"
                        :page-sizes="[5, 10, 15]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="gfrom.total">
                        </el-pagination>
                </el-tab-pane>
                <el-tab-pane label="社会招聘岗位" name="open" >
                    <template>
                        <el-table :data="openData" ref="openData"
                        border
                        stripe
                        highlight-current-row
                        v-loading="oloading"
                        style="width: 100%" >
                            <el-table-column prop="instituteName" label="单位" width="180" fixed="left" >
                            </el-table-column>
                            <el-table-column prop="orgName" label="部门" width="180" fixed="left" sortable >
                            </el-table-column>
                            <el-table-column prop="postTitle" label="岗位名称" width="180" >
                            </el-table-column>
                            <el-table-column prop="postInfo" label="岗位简介" width="220">
                            </el-table-column>
                            <el-table-column prop="needNum" label="招聘人数" width="60">
                            </el-table-column>
                            <el-table-column prop="oRangeType" label="招聘范围" width="120">
                            </el-table-column>
                            <el-table-column prop="major" label="专业" width="220">
                            </el-table-column>
                            <el-table-column prop="educationTypeName" label="学历" width="80" sortable>
                            </el-table-column>
                            <el-table-column prop="diplomaTypeName" label="学位" width="80" sortable>
                            </el-table-column>
                            <el-table-column prop="oTitleTypeName" label="职称" width="100" sortable>
                            </el-table-column>
                            <el-table-column prop="oAgeTypeName" label="年龄" width="100" sortable>
                            </el-table-column>
                            <el-table-column prop="politicalType" label="政治面貌" width="110" sortable>
                            </el-table-column>
                            <el-table-column prop="other" label="其他条件" width="180">
                            </el-table-column>
                            <el-table-column prop="oFromType" label="招聘形式" width="110" sortable>
                            </el-table-column>
                            <el-table-column prop="oTimeDesc" label="招聘时间" width="180">
                            </el-table-column>
                            <el-table-column prop="other" label="其他条件" width="220">
                            </el-table-column>
                            <el-table-column prop="remark" label="备注" width="220">
                            </el-table-column>
                            <el-table-column label="状态" width="110" align="center" fixed="right">
                                <template slot-scope="scope">
                                    <el-tag  type="primary" disable-transitions v-if="scope.row.status==0">{{scope.row.statusName}}</el-tag>
                                    <el-tag  type="danger" disable-transitions v-if="scope.row.status==10" >{{scope.row.statusName}}</el-tag>
                                    <el-tag  type="success" disable-transitions v-if="scope.row.status==20" >{{scope.row.statusName}}</el-tag>
                                    <el-tag  type="info" disable-transitions v-if="scope.row.status==-10" >{{scope.row.statusName}}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="status" label="操作" width="140" fixed="right">
                                <template slot-scope="scope">
                                    <el-button type="text"
                                    v-show="showbutn(scope.row.status)"
                                    @click.stop="changeStatus(scope.row.postId,20,'o')"
                                    size="small" class="text-success">通过</el-button>
                                    <el-button type="text"
                                    v-show="showbutn(scope.row.status)"
                                    @click.stop="changeStatus(scope.row.postId,-10,'o')"
                                    size="small" class="text-danger">不通过</el-button>
                                    <el-button type="text"
                                    v-show="showbutn(scope.row.status)"
                                    @click.stop="changeStatus(scope.row.postId,10,'o')"
                                    size="small" class="text-info">调整</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <br />
                        <el-pagination
                        background
                        @size-change="ohandleSizeChange"
                        @current-change="ohandleCurrentChange"
                        :current-page="ofrom.pageNum"
                        :page-sizes="[5, 10, 15]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="ofrom.total">
                        </el-pagination>
                    </template>
                </el-tab-pane>
              </el-tabs>
            </template>
        </HrrMainCardLayout>
	</div>
</template>
<script>
    export default {
        name: 'plan_reportout',
        data() {
            return {
                tab: 'graduates',
                searchform: {
                    pageNum:1,
                    pageSize:10,
                    planId: "",
                },
                ofrom:{
                    pageNum:1,
                    pageSize:10,
                    total:0
                },
                gfrom:{
                    pageNum:1,
                    pageSize:10,
                    total:0
                },
                planIdData:[],
                openData: [],
                graduatesData: [],
                statusData:[],
                oloading: true,
                gloading: true
            }
        },
        methods: {
            SubmitForm() {
                this.initOpenData();
                this.initgraduatesData();
            },
            ohandleSizeChange(val) {
                this.ofrom.pageSize=val;
                this.initOpenData();
            },
            ohandleCurrentChange(val) {
                this.ofrom.pageNum=val;
                this.initOpenData();
            },
             ghandleSizeChange(val) {
                this.gfrom.pageSize=val;
                this.initgraduatesData();
            },
            ghandleCurrentChange(val) {
                this.gfrom.pageNum=val;
                this.initgraduatesData();
            },
            showbutn(status){
                return status!=20 && status!=10;
            },
            initOpenData(){
                var Vuethis=this;
                this.oloading=true;
                this.searchform.pageNum=this.ofrom.pageNum;
                this.searchform.pageSize=this.ofrom.pageSize;
                this.$hrraxios.get(this.$api.plan.reportOutbjOpen,{params:this.searchform})
                .then(function (response) {
                    Vuethis.oloading=false;
                    var data=response.data;
                    if(data.success==true)
                    {
                        Vuethis.openData=data.data.list;
                        Vuethis.ofrom.total=data.data.total;
                    }else{
                        Vuethis.$message.error(data.prompt);
                    }
                })
                .catch(function (error) {
                    Vuethis.oloading=false;
                    console.log(error);
                });
            },
            initgraduatesData(){
                var Vuethis=this;
                this.gloading=true;
                this.searchform.pageNum=this.gfrom.pageNum;
                this.searchform.pageSize=this.gfrom.pageSize;
                this.$hrraxios.get(this.$api.plan.reportOutbjG,{params:this.searchform})
                .then(function (response) {
                    Vuethis.gloading=false;
                    var data=response.data;
                    if(data.success==true)
                    {
                        Vuethis.graduatesData=data.data.list;
                        Vuethis.gfrom.total=data.data.total;
                    }else{
                        Vuethis.$message.error(data.prompt);
                    }
                })
                .catch(function (error) {
                    Vuethis.gloading=false;
                    console.log(error);
                });
            },
            initData() {
                this.searchform.planId=this.planIdData[0].planId;
                this.initOpenData();
                this.initgraduatesData();
            },
            initParamsData(){
                this.$common.getplanlist(this,"planIdData",this.initData);
                this.$common.getStatus({forTable:"hrr_post"},"statusData",this);
            },
            changeStatus(postId,status,w){
                var PostStatus=(Vuethis,pid,s,w,mes)=>{
                    var Vthis=Vuethis;
                    var loading = Vthis.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var PUrl="";
                    var from={};
                    from.postId=postId;
                    if(s==20){
                        PUrl=Vthis.$api.plan.postStatusPoss;
                    }
                    if(s==10){
                        PUrl=Vthis.$api.plan.postStatusAdjuest;
                        from.message=mes;
                    }
                    if(s==-10){
                        PUrl=Vthis.$api.plan.postStatusReject;
                        from.message=mes;
                    }
                    Vuethis.$hrraxios.post(PUrl,from)
                    .then((response)=>{
                        loading.close();
                        var data = response.data;
                        if (data.success == true) {
                            Vthis.$alert("状态修改成功！",{callback:action=>{
                                if(w=="o"){
                                    Vthis.initOpenData();
                                }else{
                                    Vthis.initgraduatesData();
                                }
                            }});
                        } else {
                            Vthis.$message.error(data.prompt);
                        }
                    })
                    .catch((error) => {
                        loading.close();
                    });

                };
                if(status==20){
                    this.$confirm("确定要通过么？",{type:"warning"})
                    .then(()=>{
                        PostStatus(this,postId,status,w);
                    })
                    .catch((error)=>{
                    })
                }else{
                    this.$prompt('请输入您的建议', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                    }).then(({ value }) => {
                        PostStatus(this,postId,status,w,value);
                    }).catch(() => {

                    });
                }
            },
        },
        beforeRouteLeave(to, from, next) {
            // 导航离开该组件的对应路由时调用
            to.meta.row = from.meta.row;
            next();
        },
        created() {
            this.initParamsData();
        }
    }
</script>
